
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// import  DEVS  from "../../data/devs.data.json" assert { type: "json" }
var $84ed50905c23cb0f$exports = {};
$84ed50905c23cb0f$exports = JSON.parse('[{"title":"Camila Valderrama","img":"https://avatars.githubusercontent.com/u/145812193?v=4","linkedin":"https://www.linkedin.com/in/camilavalderrama","location":"San Fernando del Valle de Catamarca, Catamarca.","github":"https://github.com/camila-valderrama","portfolio":"https://github.com/camila-valderrama","description":"Desarrolladora Web Full Stack con conocimientos en HTML, CSS, JavaScript, Python, SQL y Git."},{"title":"Marina Benitez","img":"https://raw.githubusercontent.com/d3vh4n5/CaC-Fullstack-Node-Grupo10/92691eec0b889e64f32c1729af7beec9aea8c518/assets/img/woman.svg","linkedin":"","location":"Moron, Bs As, Argentina","github":"https://github.com/MarinaMaruka","portfolio":"","description":"Desarrolladora web Full Stack Node.js. Manejo HTML, CSS y JavaScript"},{"title":"Hugo Terrile","img":"https://media.licdn.com/dms/image/D4E03AQFgr_-YLhiGSw/profile-displayphoto-shrink_100_100/0/1680446251262?e=1725494400&v=beta&t=E_Rd00exDw1jCntz53BHuutipLu0FYerhbf6YtEGWlk","linkedin":"https://www.linkedin.com/in/hugo-terrile-it/","location":"Wembley, Inglaterra, Reino Unido","github":"https://github.com/hterrilex","portfolio":"","description":"FullStack Node || Geo Data Analyst - Dev Python"},{"title":"Juan Angel Basgal","img":"https://avatars.githubusercontent.com/u/86476526?v=4","linkedin":"https://www.linkedin.com/in/juanangelbasgall/","location":"Campana, Bs As, Argentina","github":"https://github.com/d3vh4n5","portfolio":"https://d3vh4n5.com.ar/","description":"Desarrollador FullStack - Node | Js - Ts | PHP | Python || React | Vue"}]');


const $f5b07aeb0e9ab50d$var$$template = document.getElementById("$devCard");
const $f5b07aeb0e9ab50d$var$$container = document.querySelector(".about__devs-container");
(0, (/*@__PURE__*/$parcel$interopDefault($84ed50905c23cb0f$exports))).forEach((person, index)=>{
    const $fragment = $f5b07aeb0e9ab50d$var$$template.content.cloneNode(true);
    const $card = $fragment.querySelector(".dev-card");
    if (index % 2 == 0) $card.classList.add("animate__fadeInBottomLeft");
    else $card.classList.add("animate__fadeInBottomRight");
    const $img_img = $fragment.querySelector(".dev-card__person-img");
    const $title_h = $fragment.querySelector(".dev-card__title");
    const $linkedin_a = $fragment.querySelector(".linkedin");
    const $location_s = $fragment.querySelector(".location");
    const $github_a = $fragment.querySelector(".github");
    const $portfolio_a = $fragment.querySelector(".portfolio");
    const $description_p = $fragment.querySelector(".dev-card__description");
    $img_img.src = person.img;
    $linkedin_a.href = person.linkedin;
    $github_a.href = person.github;
    $location_s.innerText = person.location;
    $title_h.innerText = person.title;
    $description_p.innerText = person.description;
    if (person.linkedin !== "") {
        const $linkedinItem = $fragment.querySelector(".linkedin-item");
        $linkedinItem.hidden = false;
        $linkedinItem.href = person.linkedin;
    }
    if (person.portfolio !== "") {
        const $portfolioItem = $fragment.querySelector(".portfolio-item");
        $portfolioItem.hidden = false;
        $portfolio_a.href = person.portfolio;
    }
    $f5b07aeb0e9ab50d$var$$container.appendChild($fragment);
});


//# sourceMappingURL=about.d7dad685.js.map
